import { Component, OnInit } from '@angular/core';
import { CrossoverService } from 'src/app/services/crossover.service';
import * as Highcharts from 'highcharts';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { HighchartsChartModule } from 'highcharts-angular';
import { TradingSystemSummaryComponent } from '../../shared/trading-system-summary/trading-system-summary.component';
import { CommonModule } from '@angular/common';
import { ListaPulsantiMercatiComponent } from "../../shared/lista-pulsanti-mercati/lista-pulsanti-mercati.component";


@Component({
  selector: 'app-analisi-h1',
  standalone: true,
  imports: [HighchartsChartModule, TradingSystemSummaryComponent, CommonModule, ListaPulsantiMercatiComponent],
  templateUrl: './analisi-h1.component.html',
  styleUrls: ['./analisi-h1.component.scss']
})
export class AnalisiH1Component implements OnInit {

  ts!: TradingSystemSummary
  markets: any[] = []

  tableData: any = []
  headers = ['market', 'punti', 'profit euro', 'operazioni', 'punti op', 'perc pos', 'media pos', 'media neg', 'rawal', 'max DD']

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {}

  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false
  MaxDD: number = 0

  constructor(private service: CrossoverService) { }

  ngOnInit(): void {
    /* this.service.listaMercati().subscribe((data: any) => {
      this.markets = data.data.filter((el: any) => el.tipo == "Cross" || el.tipo == "Major")
      console.log(this.markets)
    }) */
  }

  /* mercatoSelezionato(market: any) {
    this.selectMarket(market.toString())
  } */

  selectMarket(market: any) {
    this.service.lista_h1(market.market).subscribe((data: any) => {
      if (data.res == 'ok') {
        this.tableData = data.dati
        data.dati.map((el: any) => {
          el.punti = el.verso == 'buy' ? el.prezzoclose - el.prezzoopen : el.prezzoopen - el.prezzoclose
        })
        //let m = this.markets.find((el: any) => el.market == market)
        this.ts = new TradingSystemSummary().popolaDati(market.market, market.pip, data.dati)
        this.ts.spread = market.spread
        this.aggiornaGrafico(market.market, data.dati)
      }
    })
  }

  aggiornaGrafico(mkt: string, dati: any[]) {
    let p = 0;
    let progr = dati.map((a: any) => {
      p += +a.punti
      return [a.oraclose,p]
    })
    let pm = 0
    let pMax = 0
    progr.map((a: any) => {
      pm = a[1] > pm ? a[1] : pm
      pMax = (pm - a[1]) > pMax ? (pm - a[1]) : pMax
    })
    let mk = this.tableData.find((el: any) => el.market == mkt)
    mk.maxdd = pMax
    this.MaxDD = pMax
    this.chartOptions = {
      title: {
        text: mkt
      },
      series: [{
        data: progr,
        type: 'line',
        turboThreshold: 3000
      }
      ]
    }
  }
}
